
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Sidebar',
  emits: ['state-change'],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
})
